var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransaction1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5251_10486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1111 10.5556C10.9644 10.5556 9.22222 12.2978 9.22222 14.4444C9.22222 16.5911 10.9644 18.3333 13.1111 18.3333C15.2578 18.3333 17 16.5911 17 14.4444C17 12.2978 15.2578 10.5556 13.1111 10.5556ZM14.3944 16.2722L12.7222 14.6V12.1111H13.5V14.2811L14.9389 15.72L14.3944 16.2722ZM13.8889 3.55556H11.4156C11.0889 2.65333 10.2333 2 9.22222 2C8.21111 2 7.35556 2.65333 7.02889 3.55556H4.55556C3.7 3.55556 3 4.25556 3 5.11111V16.7778C3 17.6333 3.7 18.3333 4.55556 18.3333H9.30778C8.84889 17.89 8.47556 17.3611 8.20333 16.7778H4.55556V5.11111H6.11111V7.44444H12.3333V5.11111H13.8889V9.06222C14.4411 9.14 14.9622 9.30333 15.4444 9.52889V5.11111C15.4444 4.25556 14.7444 3.55556 13.8889 3.55556ZM9.22222 5.11111C8.79444 5.11111 8.44444 4.76111 8.44444 4.33333C8.44444 3.90556 8.79444 3.55556 9.22222 3.55556C9.65 3.55556 10 3.90556 10 4.33333C10 4.76111 9.65 5.11111 9.22222 5.11111Z",
    fill: "#99D7D4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5251_10486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction1);
export default __webpack_public_path__ + "static/media/transaction1.d2f567d8f85ff652de331ade64045e21.svg";
export { ForwardRef as ReactComponent };